import { render, staticRenderFns } from "./AdminNmea.vue?vue&type=template&id=48d88970&scoped=true"
import script from "./AdminNmea.vue?vue&type=script&lang=ts"
export * from "./AdminNmea.vue?vue&type=script&lang=ts"
import style0 from "./AdminNmea.vue?vue&type=style&index=0&id=48d88970&prod&scoped=true&lang=css"
import style1 from "./AdminNmea.vue?vue&type=style&index=1&id=48d88970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d88970",
  null
  
)

export default component.exports